import { Maybe, Operation } from '../../../__generated__/globalTypes'

import {
  ItemFragment,
  itemFragmentString,
} from '../../fragments/__generated__/ItemFragment'

import { sendDelayFragmentString } from '../../fragments/__generated__/SendDelayFragment'

import { campaignFragmentString } from '../../fragments/__generated__/CampaignFragment'

import { campaignLineFragmentString } from '../../fragments/__generated__/CampaignLineFragment'

import { minimalPanelFragmentString } from '../../fragments/__generated__/MinimalPanelFragment'

import { giftVariationFragmentString } from '../../fragments/__generated__/GiftVariationFragment'

import { amountFragmentString } from '../../fragments/__generated__/AmountFragment'

import { priceFragmentString } from '../../fragments/__generated__/PriceFragment'

import getItemsRawString from '../GetItems.graphql'

const getItemsString = [
  getItemsRawString,
  itemFragmentString,
  sendDelayFragmentString,
  campaignFragmentString,
  campaignLineFragmentString,
  minimalPanelFragmentString,
  giftVariationFragmentString,
  amountFragmentString,
  priceFragmentString,
].join('\n\n')

export type GetItemsData = {
  items: ItemFragment[]
}

export type GetItemsVariables = {
  search?: Maybe<string>
  category?: Maybe<string>
}

export type GetItems = Operation<GetItemsData, GetItemsVariables>

export const GetItems = ({
  search,
  category,
}: GetItemsVariables = {}): GetItems => ({
  query: getItemsString,
  variables: {
    search,
    category,
  },
})
